var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{staticClass:"mt-4",attrs:{"full-width":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }